const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

let loadPromise = null;

const loadRazorpayScript = () => {
    if (window.Razorpay) {
        return Promise.resolve(window.Razorpay);
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${RAZORPAY_SCRIPT_URL}"]`);

        if (existingScript) {
            existingScript.addEventListener('load', () => resolve(window.Razorpay));
            existingScript.addEventListener('error', () => {
                loadPromise = null;
                reject(new Error('Failed to load Razorpay'));
            });
            return;
        }

        const script = document.createElement('script');
        script.src = RAZORPAY_SCRIPT_URL;
        script.async = true;
        script.onload = () => {
            if (window.Razorpay) {
                resolve(window.Razorpay);
                return;
            }

            loadPromise = null;
            reject(new Error('Razorpay failed to initialize'));
        };
        script.onerror = () => {
            loadPromise = null;
            reject(new Error('Failed to load Razorpay'));
        };
        document.body.appendChild(script);
    });

    return loadPromise;
};

export default loadRazorpayScript;
